import { useEffect, useState } from "react";
import { PageHero, Container } from "../components/Section";
import { api } from "../lib/api";
import { Mail, Phone } from "lucide-react";

export default function LeadersDirectory() {
  const [leaders, setLeaders] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/leaders").then((r) => setLeaders(r.data)).catch(() => {});
  }, []);

  const visible = leaders.filter((l) =>
    !q || [l.name, l.role, l.ministry, l.email].join(" ").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="leaders-directory-page">
      <PageHero
        overline="Ministry Leaders Directory"
        title={<>Reach out. <em className="text-gold-light italic font-light">Connect.</em></>}
        kicker="Direct contact info for every ministry leader at Sixth Mount Zion."
      />

      <Container className="pb-32">
        <div className="mb-10">
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search by name, ministry, or role…"
            className="w-full md:w-96 bg-transparent border-0 border-b border-white/15 text-white px-0 py-3 focus:outline-none focus:border-gold transition-colors"
            data-testid="leaders-search-input"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {visible.map((l) => (
            <div key={l.id} className="bg-wine-950 p-8" data-testid={`leader-${l.id}`}>
              <div className="font-serif text-2xl font-bold mb-1">{l.name}</div>
              <div className="text-xs uppercase tracking-widest text-gold mb-1">{l.role}</div>
              <div className="text-sm text-white/55 mb-5">{l.ministry}</div>
              <div className="space-y-2 text-sm">
                {l.email && (
                  <a href={`mailto:${l.email}`} className="flex items-center gap-2 text-white/85 hover:text-gold transition-colors">
                    <Mail className="h-4 w-4 text-gold/70" /> {l.email}
                  </a>
                )}
                {l.phone && (
                  <a href={`tel:${l.phone}`} className="flex items-center gap-2 text-white/85 hover:text-gold transition-colors">
                    <Phone className="h-4 w-4 text-gold/70" /> {l.phone}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
